
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux"
import {DashboardContainer } from "../../funcs/utils";
import { Popup } from "../../../lib/onboarding-shared/popup";
import { render_price, render_price_2 } from "./common";
import { sprintf } from "sprintf-js";
import { DashboardTable } from "../dashboard-table";
import { Doughnut } from "../doughnut";
import { DashTitle } from "../../funcs/utils";
import { getRGB } from "../../../lib/color";
import { rem_to_px } from "../../helper/px";
import { DEVICE } from "../../../lib/constants";
import {process_pay_frequency} from "../../../lib/time/pay_frequency";
import {day_diff, MMDDYYYY_to_date, today_no_time} from "../../../lib/time";

const MENUS = [
  {
    id: "securities",
    label: "Securities",
  },
  {
    id: "asset_class",
    label: "Asset Class Allocation",
  },
  {
    id: "investment_category",
    label: "Investment Category",
  },
  {
    id: "investment_type",
    label: "Investment Type",
  },
  {
    id: "global",
    label: "Global Diversification",
  },
];

const TABLE_0 = "TABLE_0";
const TABLE_1 = "TABLE_1";

const holding_to_table = id => {
  if (id === "securities") {
    return TABLE_0;
  }
  return TABLE_1;
};

const calc_align = table_id => {
  if (table_id === TABLE_0) {
    return [ "center", "right", "center", "right", "right", "right", "right", "right"];
  } else if (table_id === TABLE_1) {
    return [ "left", "right", "right", "right", "right"];
  }
}

const calc_col_widths = table_id => {
  if (table_id === TABLE_0) {
    return [ 1., 1., 1., 1.,  1., 1., 1., 1. ];
  } else if (table_id === TABLE_1) {
    return [ 4., 1., 1., 1., 1. ];
  }
}

const on_menu_mouse_over = (component, id, mouse_over) => () => {
  if (mouse_over) {
    component.setState({
      holdings_menu_mouse_over: id,
    })
  } else {
    if (component.state.holdings_menu === id) {
      component.setState({
        holdings_menu_mouse_over: "",
      })
    }
  }
};

const renderMenu = (component, small_device) => {

  const selected_color = getRGB(component.props.client.color.sign_on_button);

  const render_button = (item, index) => {
    const style = {
      fontWeight: "bold",
      fontSize: small_device ? "1rem" : "1.1rem",
      cursor: "pointer",
    }
    if (component.state.holdings_menu === item.id) {
      style.color = selected_color;
    } else if (component.state.holdings_menu_mouse_over === item.id) {
      style.color = "#000";
    }
    const on_click = (id) => () => {
      component.setState({
        holdings_menu: id,
      });
    }
    return (
      <div
        key={index}
        onClick={on_click(item.id)}
        onMouseOver={on_menu_mouse_over(component, item.id, true)}
        onMouseOut={on_menu_mouse_over(component, item.id, false)}>
        <span style={style}>{ item.label }</span>
      </div>
    )
  };

  const div_style = {};
  if (small_device) {
    div_style.paddingTop = "1rem";
    div_style.paddingBottom = "4rem";
  } else {
    div_style.display = "flex";
    div_style.justifyContent = "flex-end";
  }

  let menus, filler;
  // BD only shows the first menu option
  if (component.props.app.wlf.broker_dealer) {
    menus = [MENUS[0]];
    filler = (<div style={{ height: "4rem"}}/>);
  } else {
    menus = MENUS;
    filler = null;
  }

  return (
    <div style={div_style}>
      <div>
        { menus.map(render_button)}
        { filler }
      </div>
    </div>
  )
}

const setup_holdings_state = () => {
  return {
    selected_sym_index: -1,
    selected_sym: "",
    holdings_menu: MENUS[0].id,
    holdings_menu_mouse_over: "",
  }
};

const render_header = (text, override, sortConfig, setSortConfig) => {
    // const { key, direction } = sortConfig;
    const { direction } = sortConfig;
    // const [ isSelected, setIsSelected ] = useState(text === key);
    const handleOnClick = () => {
        if(!setSortConfig) {
            return;
        }

        setSortConfig({ key: text, direction: direction === 'asc' ? 'desc' : 'asc' })
    }

  const spanStyle = {
    fontWeight: "bold",
    fontSize: "1.4rem",
    ...override,
  };

//   const Arrow = () => {
//     return (
//         <React.Fragment>
//              { direction === 'asc' ? <i className="fa fa-arrow-up"/> : <i className="fa fa-arrow-down"/> }
//         </React.Fragment>
//     )
//   }

//     return (
//         <div style={{ bottom: "0px" }} onClick={handleOnClick}>
//             <div style={{ display: "flex", gap: "8px", alignItems: "center", height: "1.4rem" }}>
//                 <div style={spanStyle}>{text}</div>
//                 {isSelected && <Arrow />}
//             </div>
//         </div>
//     )

  return (
    <div onClick={handleOnClick}>
      <div style={{height: "1.4rem"}}/>
        <div>
            <span style={spanStyle}>{ text }</span>
        </div>
    </div>
  )
};

const render_header_2 = (text_0, text_1, override, sortConfig, setSortConfig) => {
    // const { key, direction } = sortConfig;
    const { direction } = sortConfig;
    const handleOnClick = () => {
        if(!setSortConfig) {
            return;
        }

        setSortConfig({ key: `${text_0} ${text_1}`, direction: direction === 'asc' ? 'desc' : 'asc' })
    }

  const spanStyle = {
    fontWeight: "bold",
    fontSize: "1.4rem",
    ...override,
  };

  return (
    <div onClick={handleOnClick}>
      <div>
        <span style={spanStyle}>{ text_0 }</span>
      </div>
      <div>
        <span style={spanStyle}>{ text_1 }</span>
      </div>
    </div>
  )
}

const on_mouse_over = (component, index, sym, mouse_over) => (ev) => {
  if (mouse_over) {
    component.setState({
      selected_sym_index: index,
      selected_sym: sym,
    })
  } else {
    if (component.state.selected_sym_index === index) {
      component.setState({
        selected_sym_index: -1,
        selected_sym: "",
      })
    }
  }
}

export const render_doughnut = (component, app) => {
  const rem = 30;
  const holdings_id = component.state.holdings_menu;
  const holdings = component.getUserDashboard().holdings[holdings_id];

  const sym_fn = item => {
    const sym = item.id;
    const result = {
      color: item.color,
      pct: item.holding_pct / 100.,
    };
    if (component.state.selected_sym_index === -1) {
      if (holdings.largest_holdings.includes(sym)) {
        result.label = item.popup;
      }
    } else if (component.state.selected_sym === sym.toUpperCase()) {
      result.label = item.popup;
    }

    return result;
  }
  const generate_doughnut_data = () => {
    if (!holdings) {
      return [];
    }
    return holdings.all_data.map(sym_fn);
  }
  
  const getSizeRem = (sizeRem) => {
    const size_px = rem_to_px(sizeRem)
    if(app.width <= size_px)
    {
        return sizeRem - 10;
    }
    return sizeRem;
  }

  const containerStyle = {
      display: "flex",
      justifyContent: "center"
  }

  const overlayStyle = {
    width: "100%",
    height: "100%",
    position: "relative",
    top: "0",
    left: sprintf("-%drem", getSizeRem(rem)),
    //background: "rgba(255, 0, 0, 0.2)"
  };

  return (
    <Doughnut
      sizeRem={getSizeRem(rem)}
      innerRad={0.4}
      outerRad={0.6}
      spokeRad={0.7}
      labelRad={0.8}
      items={generate_doughnut_data()}
      containerStyle={containerStyle}
      overlayStyle={overlayStyle}/>
  );
};

const get_holdings_header_data = (component, table_id, no_performance, show_corp_events, sortConfig, setSortConfig) => {

  const header_style = {
    fontSize: "1rem",
  }
  const data = [];

//   const live_px = component.getUserDashboard().live_px;
//   const popup_style = {
//     fontWeight: "normal",
//     right: "0",
//   }
//   const info = (
//     <Info
//       popup_style={popup_style}
//       component={component}
//       id={"live_px"}
//       text={"Live prices are delayed 15min"}
//       />
//   );

//   const current_hdr = live_px ?
//     (<span>Current{info}</span>) : "Current";

  if (table_id === TABLE_0) {
    const line = [];
    line.push(render_header("Symbol", header_style, sortConfig, setSortConfig));
    line.push(render_header("Name", header_style, sortConfig));
    if (show_corp_events) {
      line.push(render_header("Coupon", header_style, sortConfig));
      line.push(render_header("Maturity", header_style, sortConfig));
      line.push(render_header_2("Payment", "Freq", header_style, sortConfig));
    }
    line.push(render_header_2("Closing", "Price", header_style, sortConfig));
    line.push(render_header("Quantity", header_style, sortConfig));
    line.push(render_header_2("Closing", "Value", header_style, sortConfig, setSortConfig));
    line.push(render_header("Holding %", header_style, sortConfig, setSortConfig));
    if (show_corp_events) {
      line.push(render_header_2("Days To", "Maturity", header_style, sortConfig));
    }

    if (!no_performance) {
      line.push(render_header_2("Current", "Price", header_style, sortConfig));
      line.push(render_header_2("Daily", "Gain $", header_style, sortConfig, setSortConfig));
      line.push(render_header_2("Daily", "Gain %", header_style, sortConfig, setSortConfig));
    }
    data.push(line);

  } else if (table_id === TABLE_1) {
    data.push(
      [
        render_header("Symbol", header_style, sortConfig, setSortConfig),
        render_header_2("Closing", "Value", header_style, sortConfig, setSortConfig),
        render_header("Holding %", header_style, sortConfig, setSortConfig),
        render_header_2("Daily", "Gain $", header_style, sortConfig, setSortConfig),
        render_header_2("Daily", "Gain %", header_style, sortConfig, setSortConfig),
      ]
    )
  }

  return data;
};

const get_holdings_body_data = (component, table_id, no_performance, show_corp_events, sortKey) => {
    const price_style = {
      fontSize: "1rem",
    };

    const label_style = {
        cursor: "pointer"
    };

    const holdings_id = component.state.holdings_menu;
    const holdings = component.getUserDashboard().holdings[holdings_id];
    const data = [];

    if (!holdings) {
      return data;
    }

    const dataToSortBy = [];
    holdings.table.forEach((sym, index) => {
      const sym_data = holdings.all_data.find(item => item.id === sym);
      const sym_metadata = sym_data.metadata && sym_data.metadata.security;
      const gain_style = {
        color: sym_data.daily_gain < 0 ? "#F00" : "#008040",
      };
      const popup_style = {
        padding: "0.5rem 1rem"
      }
      let popup = index === component.state.selected_sym_index
        ? (
          <Popup translate_y={"-4rem"} style={popup_style}>
            <span>{sym_data.popup}</span>
          </Popup>
        ) : null;

      const name_style = {
        width: "10rem",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
      }
      const mouse_over_props = {
        onMouseOver: on_mouse_over(component, index, sym_data.id, true),
        onMouseOut: on_mouse_over(component, index, sym_data.id, false),
      }
      
      const sym_label = sym_data.label;

      switch(sortKey) {
        case 'Symbol': 
            dataToSortBy.push(sym_label);
            break;
        case 'Closing Value': 
            dataToSortBy.push(sym_data.closing_price);
            break;
        case 'Holding %':
            dataToSortBy.push(sym_data.holding_pct);
            break;
        case 'Daily Gain $':
            dataToSortBy.push(sym_data.daily_gain);
            break;
        case 'Daily Gain %':
            dataToSortBy.push(sym_data.daily_gain_pct);
            break;
        default:
            break;
      }

      if (table_id === TABLE_0) {
        const line = [];

        // Symbol
        line.push((<div
            style={label_style}
            {...mouse_over_props}>
            <span>
              {sym_label}
            </span>
            { popup }
          </div>));

        // Name
        line.push((<div {...mouse_over_props} style={name_style}>{sym_data.popup}</div>));

        if (show_corp_events) {
          let coupon_str = "---";
          if (sym_metadata && 'Coupon' in sym_metadata) {
            coupon_str = sprintf("%.2f%%", sym_metadata.Coupon);
          }
          line.push(coupon_str);

          let maturity_str = "---";
          if (sym_metadata && sym_metadata.Maturity) {
            maturity_str = sym_metadata.Maturity;
          }
          line.push(maturity_str);

          let pay_freq_str = "---";
          if (sym_metadata && sym_metadata['Pay Frequency']) {
            pay_freq_str = process_pay_frequency(sym_metadata['Pay Frequency']);
          }
          line.push(pay_freq_str);
        }
        
        // Closing Price
        line.push(render_price(sym_data.closing_price, null, price_style));

        // Quantity
        line.push((<span>{sym_data.size}</span>));

        // Closing Value
        line.push(render_price(sym_data.closing_value, null, price_style));

        // Holding %
        line.push((<span>{ sprintf("%.2f %%", sym_data.holding_pct)} </span>));

        if (show_corp_events) {
          let days_to_maturity_str = "---";
          if (sym_metadata && sym_metadata.Maturity) {
            const today = today_no_time();
            const mat = MMDDYYYY_to_date(sym_metadata.Maturity);
            days_to_maturity_str = sprintf("%d", day_diff(today, mat));
          }
          line.push(days_to_maturity_str);
        }

        if (!no_performance) {
          // Current Price
          line.push(render_price(sym_data.current_price, null, price_style));

          // Daily Gain $
          line.push(render_price_2(sym_data.daily_gain, null, price_style));

          // Daily Gain %
          line.push((sym_data.daily_gain_pct && <span style={gain_style}>{ sprintf("%.2f %%", sym_data.daily_gain_pct)} </span>));
        }

        data.push(line);

      } else if (table_id === TABLE_1) {
        data.push([
          (<div
            style={label_style}
            {...mouse_over_props}>
            <span>
              {sym_label}
            </span>
            { popup }
          </div>),
          render_price(sym_data.closing_value, null, price_style),
          (<span>{ sprintf("%.2f %%", sym_data.holding_pct)} </span>),
          render_price_2(sym_data.daily_gain, null, price_style),
          (sym_data.daily_gain_pct && <span style={gain_style}>{ sprintf("%.2f %%", sym_data.daily_gain_pct)} </span>),
        ])
  
      }
    });
    return [ data, dataToSortBy ];
  }

const sortHoldingsBodyData = (holdingsBodyData, dataToSortBy, direction) => {
    if(dataToSortBy.length === 0) {
        return holdingsBodyData;
    }

    const data = holdingsBodyData.reduce((list, jsxBodyData, index) => {
        list.push({ jsxBodyData, rawData: dataToSortBy[index] });

        return list;
    }, []);

    const sortedData = [...data].sort((a, b) => {
        if (a.rawData < b.rawData) return direction === 'asc' ? -1 : 1;
        if (a.rawData > b.rawData) return direction === 'asc' ? 1 : -1;
        return 0;
    });

    const sortedBodyData = sortedData.reduce((list, data) => {
        list.push(data.jsxBodyData);

        return list;
    }, []);

    return sortedBodyData;
}
const render_holdings_table = (component, table_id, small_device, no_performance, show_corp_events) => {
    const tableStyle = {
      transform: "translateY(-3rem)",
      marginTop: "0 !important",
      overflowX: "auto",
      paddingRight: "0.5rem",
      paddingLeft: "1rem",
      display: "block",
    };
    if (!small_device) {
      //tableStyle.width = "66.66%";
    }

    const [sortConfig, setSortConfig] = useState({ key: 'Symbol', direction: 'asc' });
    const holdingsHeaderData = get_holdings_header_data(component, table_id, no_performance, show_corp_events, sortConfig, setSortConfig);
    const [holdingsBodyData, dataToSortBy] = get_holdings_body_data(component, table_id, no_performance, show_corp_events, sortConfig.key);
    const [sortedData, setSortedData] = useState(holdingsHeaderData.concat(holdingsBodyData));

    useEffect(() => {
       const sortedBodyData = sortHoldingsBodyData(holdingsBodyData, dataToSortBy, sortConfig.direction);
       setSortedData(holdingsHeaderData.concat(sortedBodyData));
    }, [sortConfig.key, sortConfig.direction, holdingsBodyData]);

    const style_lut = [
      {
        pred: (row, col) => row === 0,
        style: {
          overflow: "inherit",
        }
      }
      ];
    return (
      <div>
        <DashboardTable
          tbody_style={{ overflow: "auto" }}
          title={"Holdings"}
          tdStyleLut={style_lut}
          col_widths={calc_col_widths(table_id)}
          tableStyle={tableStyle}
          align={calc_align(table_id)}
          data={sortedData}/>
      </div>
    )
}

// these are your props
const render_holdings_2 = ({component, onTitleClick, app, no_performance}) => {
  const header_style = {
    borderBottom: "1pt solid black",
    paddingBottom: "0",
    marginBottom: "0.75rem",
  };
  const wlf = app.wlf;
  const show_corp_events = wlf.ui && wlf.ui.user_dashboard_corp_events;
  const holdings_id = component.state.holdings_menu;
  const holdings = component.getUserDashboard().holdings[holdings_id];
  const is_empty = holdings && !!holdings.empty;
  const table_id = holding_to_table(holdings_id);
  const title = "Holdings";
  const small_device = component.props.app.device === DEVICE.small ||
    component.props.app.device === DEVICE.tiny;
  const titleStyle = {};
  const menuStyle = {};

  if (small_device) {
    titleStyle.display = "block";
    menuStyle.display = "block";
  } else {
    titleStyle.display = "inline-block";
    titleStyle.width = "50%";
    menuStyle.display = "inline-block";
    menuStyle.float = "right";
  }

  const device = {
    width: app.width,
  }
  return (
    <div>
      { /* header */ }
      <div style={header_style}>
        <div style={titleStyle}>
          <DashTitle
            title={title}
            device={device}
            client={component.props.client}
            onTitleClick={onTitleClick}
            style={{margin: 0}}/>
        </div>
        <div style={titleStyle}>
          { renderMenu(component, small_device) }
        </div>
      </div>

      { /* body */ }
      <div className="columns holdings-card-content-container-responsive">
        {render_holdings_table(component, table_id, small_device, no_performance, show_corp_events)}
        {!is_empty && render_doughnut(component, app)}
      </div>
    </div>
  )
};

const Holdings_ = props => {

  const device = {
    width: props.app.width,
  }
  return (
    <DashboardContainer
      device={device}
      client={props.client}>
      { render_holdings_2(props) }
    </DashboardContainer>
  )
};

const mapStateToProps = state => {
  return {
    app: state.app,
  }
}

const Holdings = connect(mapStateToProps)(Holdings_);

export { setup_holdings_state, Holdings };
